import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component';

@Component({
  selector: 'question-checkbox',
  templateUrl: './question-checkbox.component.html',
  styleUrls: ['./question-checkbox.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionCheckboxComponent extends QuestionComponent {}
